<mat-toolbar color="primary">
  <mat-toolbar-row>
    <button type="button"
      mat-icon-button
      [disabled]="!isAuthorized"
      (click)="onOpenNavigationMenu()">
      <mat-icon>
        menu
      </mat-icon>
    </button>
    <hq-page-title></hq-page-title>
  </mat-toolbar-row>
</mat-toolbar>

@if (isImpersonating) {
  <hq-impersonation-bar>
  </hq-impersonation-bar>
}

<mat-progress-bar [mode]="progressBarMode"
  [value]="100"
  color="accent"
  class="progress-bar">
</mat-progress-bar>
